import { render, staticRenderFns } from "./MemberClassesCourse.vue?vue&type=template&id=2e1cb6bc&scoped=true&"
import script from "./MemberClassesCourse.vue?vue&type=script&lang=js&"
export * from "./MemberClassesCourse.vue?vue&type=script&lang=js&"
import style0 from "./MemberClassesCourse.vue?vue&type=style&index=0&id=2e1cb6bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1cb6bc",
  null
  
)

export default component.exports